module.exports = __webpack_public_path__ + "img/profilepic.5a021ab9.png";